import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';
import { InjuredPersonForm } from './injured-person-form';
import { CustomValidator } from '../../../../../../../common/forms/custom.validators';
import { RoadControlsForm } from '../../../../common/components/road-controls-set/road-controls.form';
import { environment } from '../../../../../../../../environments/environment';

@Injectable()
export class EventForm extends RoadControlsForm {
  constructor() {
    super({
      provideDateRangeDescription: new FormControl(false),
      eventLocation: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      eventDescription: new FormControl(null, [Validators.required]),
      geometry: new FormControl(null, environment.production ? Validators.required : []),
      city: new FormControl(null, Validators.maxLength(255)),
      description: new FormControl(null, [Validators.maxLength(5000), Validators.required]),
      injuredDataSameAsApplicant: new FormControl(false, { nonNullable: true }),
      injuredWas: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      damageType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      servicesNotifiedAboutEvent: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      damageLiquidationMethod: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      accountNumber: new FormControl(null, [Validators.maxLength(255), CustomValidator.bankAccountNumber()]),
      additionalInformation: new FormControl(null, [Validators.maxLength(5000), Validators.required])
    });
    this.provideDateRangeDescriptionChange(false);
    this.injuredDataSameAsApplicantChange(false);
  }

  public get servicesNotifiedAboutEventDesc(): FormControl | null {
    return this.get('servicesNotifiedAboutEventDesc') as FormControl | null;
  }

  public servicesNotifiedAboutEventChange(v: string): void {
    if (v === 'Inne służby') {
      this.addControl('servicesNotifiedAboutEventDesc', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('servicesNotifiedAboutEventDesc');
    }
  }

  public get injuredWasDesc(): FormControl | null {
    return this.get('injuredWasDesc') as FormControl | null;
  }

  public injuredWasChange(v: string): void {
    if (v === 'Inne') {
      this.addControl('injuredWasDesc', new FormControl('', [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('injuredWasDesc');
    }
  }

  public get injuredPersonForm(): InjuredPersonForm | null {
    return this.get('injuredPerson') as InjuredPersonForm | null;
  }

  public injuredDataSameAsApplicantChange(v: boolean): void {
    if (v) {
      this.removeControl('injuredPerson');
    } else {
      this.addControl('injuredPerson', new InjuredPersonForm());
    }
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public get eventStartDate(): FormControl | null {
    return this.get('eventStartDate') as FormControl | null;
  }

  public get eventStartTime(): FormControl | null {
    return this.get('eventStartTime') as FormControl | null;
  }

  public get dateRangeDescription(): FormControl | null {
    return this.get('dateRangeDescription') as FormControl | null;
  }

  public provideDateRangeDescriptionChange(v: boolean): void {
    if (v) {
      this.removeControl('eventStartDate');
      this.removeControl('eventStartTime');
      this.addControl('dateRangeDescription', new FormControl('', [Validators.required, Validators.maxLength(1000)]));
    } else {
      this.addControl('eventStartDate', new FormControl(null, Validators.required));
      this.addControl('eventStartTime', new FormControl(null, Validators.required));
      this.removeControl('dateRangeDescription');
    }
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value,
      dateRangeDescription: this.value?.dateRangeDescription || null,
      injuredWasDesc: this.value?.injuredWasDesc || null,
      servicesNotifiedAboutEventDesc: this.value?.servicesNotifiedAboutEventDesc || null,
      ...this.injuredPersonForm?.toWriteModel()
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);

    this.provideDateRangeDescriptionChange(!!value.provideDateRangeDescription);
    this.eventStartDate?.setValue(value?.eventStartDate || null);
    this.eventStartTime?.setValue(value?.eventStartTime || null);
    this.dateRangeDescription?.setValue(value?.dateRangeDescription || '');

    this.injuredDataSameAsApplicantChange(!!value?.injuredDataSameAsApplicant);
    this.injuredPersonForm?.patchFormValues(value);

    this.injuredWasChange(value?.injuredWas || '');
    this.injuredWasDesc?.setValue(value?.injuredWasDesc || '');

    this.servicesNotifiedAboutEventChange(value?.servicesNotifiedAboutEvent || '');
    this.servicesNotifiedAboutEventDesc?.setValue(value?.servicesNotifiedAboutEventDesc || '');
  }
}
